export interface ClientAccountWillGuardian {
    id?: string | null;
    name: string | null;
    version?: number;

}

export function createClientAccountWillGuardian(): ClientAccountWillGuardian {
    return {
        name: null,
    };
}
